import actions from './actions';
import { createReducer } from '../../helpers/reducer';

const initState = {
  isCreateSavedSearchLoading: false,
  isDeleteSavedSearchLoading: false,
};

function onCreateSavedSearch(state) {
  return {
    ...state,
    isCreateSavedSearchLoading: true,
  };
}

function onCreateSavedSearchSuccess(state) {
  return {
    ...state,
    isCreateSavedSearchLoading: false,
  };
}

function onDeleteSavedSearch(state) {
  return {
    ...state,
    isDeleteSavedSearchLoading: true,
  };
}

function onDeleteSavedSearchSuccess(state) {
  return {
    ...state,
    isDeleteSavedSearchLoading: false,
  };
}

export default createReducer(initState, {
  [actions.CREATE_SAVED_SEARCH_REQUEST]: onCreateSavedSearch,
  [actions.CREATE_SAVED_SEARCH_SUCCESS]: onCreateSavedSearchSuccess,
  [actions.DELETE_SAVED_SEARCH_REQUEST]: onDeleteSavedSearch,
  [actions.DELETE_SAVED_SEARCH_SUCCESS]: onDeleteSavedSearchSuccess,
});
